import { render, staticRenderFns } from "./searchHomepage.vue?vue&type=template&id=196e88a0&scoped=true"
import script from "./searchHomepage.vue?vue&type=script&lang=js"
export * from "./searchHomepage.vue?vue&type=script&lang=js"
import style0 from "../../../static/css/searchpage.css?vue&type=style&index=0&id=196e88a0&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196e88a0",
  null
  
)

export default component.exports